<app-wrapper class="settings-page" [hideServices]=true>

  <div class="service-content {{store.state.common.sidemenuSmall ? 'sidemenu-small' : ''}} container-fluid h-100">
    <div class="row pt-5 px-3 w-100 m-0" (window:resize)="onResize($event)">

      <div class="col-12 new-tab-container" id="tabsContainer">
        <ul class="nav nav-tabs new-tabs" id="tabsList">
          <li class="{{ selectedTab === 'general' ? 'active' : ''}}" (click)="selectedTab = 'general'"><span>{{'Instance
              general' | translate}}</span></li>
          <li class="{{ selectedTab === 'locales' ? 'active' : ''}}" (click)="selectedTab = 'locales'">
            <span>{{'Languages and currencies' | translate}}</span>
          </li>
          <li class="{{ selectedTab === 'display' ? 'active' : ''}}" (click)="selectedTab = 'display'"><span>{{'Display
              system' | translate}}</span></li>
          <li class="{{ selectedTab === 'publishing' ? 'active' : ''}}" (click)="selectedTab = 'publishing'">
            <span>{{'Publishing options' | translate}}</span>
          </li>
          <li class="{{ selectedTab === 'datasources' ? 'active' : ''}}" (click)="selectedTab = 'datasources'">
            <span>{{'Supported datasources' | translate}}</span>
          </li>
          <li class="{{ selectedTab === 'time' ? 'active' : ''}}" (click)="selectedTab = 'time'"><span>{{'Time
              management' | translate}}</span></li>
        </ul>

        <ul role="tablist" class="nav nav-tabs new-tabs dropdown-tabs" id="tabsResp">
          <li class="dropdown active" dropdown>
            <a class="" href="#" (click)="false" dropdownToggle>
              <span *ngIf="selectedTab === 'general'">{{ 'Instance general' | translate }}</span>
              <span *ngIf="selectedTab === 'locales'">{{ 'Languages and currencies' | translate }}</span>
              <span *ngIf="selectedTab === 'display'">{{ 'Display system' | translate }}</span>
              <span *ngIf="selectedTab === 'publishing'">{{ 'Publishing options' | translate }}</span>
              <span *ngIf="selectedTab === 'datasources'">{{ 'Supported datasources' | translate }}</span>
              <span *ngIf="selectedTab === 'time'">{{ 'Time management' | translate }}</span>
              <i class="fas fa-angle-down ml-3"></i>
              <i class="fas fa-angle-up ml-3"></i>
            </a>
            <div class="dropdown-menu dropdown-menu-left" *dropdownMenu>
              <a *ngIf="selectedTab !== 'general'" (click)="selectedTab = 'general'" class="dropdown-item py-2"
                [ngClass]="{'active': selectedTab === 'general'}" role="tab">
                <span>{{ 'Instance general' | translate }}</span>
              </a>
              <a *ngIf="selectedTab !== 'locales'" (click)="selectedTab = 'locales'" class="dropdown-item py-2"
                [ngClass]="{'active': selectedTab === 'locales'}" role="tab">
                <span>{{ 'Languages and currencies' | translate }}</span>
              </a>
              <a *ngIf="selectedTab !== 'display'" (click)="selectedTab = 'display'" class="dropdown-item py-2"
                [ngClass]="{'active': selectedTab === 'display'}" role="tab">
                <span>{{ 'Display system' | translate }}</span>
              </a>
              <a *ngIf="selectedTab !== 'publishing'" (click)="selectedTab = 'publishing'" class="dropdown-item py-2"
                [ngClass]="{'active': selectedTab === 'publishing'}" role="tab">
                <span>{{ 'Publishing options' | translate }}</span>
              </a>
              <a *ngIf="selectedTab !== 'datasources'" (click)="selectedTab = 'datasources'" class="dropdown-item py-2"
                [ngClass]="{'active': selectedTab === 'datasources'}" role="tab">
                <span>{{ 'Supported datasources' | translate }}</span>
              </a>
              <a *ngIf="selectedTab !== 'time'" (click)="selectedTab = 'time'" class="dropdown-item py-2"
                [ngClass]="{'active': selectedTab === 'time'}" role="tab">
                <span>{{ 'Time management' | translate }}</span>
              </a>
            </div>
          </li>
        </ul>

        <div class="tab-content {{(selectedTab === 'general' || tabsType === 'dropdown') ? 'first-tab' : ''}}">

          <div *ngIf="selectedTab === 'general'" class="p-4">
            <div class="form-group mt-0">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'Site name' | translate }}</label>
                  <div class="table-items">
                    <div class="item">
                      <div class="row">
                        <div class="col-10">
                          <input type="text" name="siteName" [(ngModel)]="systemProperties.siteName"
                            class="form-control">
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                          <button class="editBtn btn-dark" (click)="updateServiceProperties()">
                            {{ 'Update' | translate }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'header.systemlogo' | translate }}</label>
                  <file-handler [fileId]="logoUrl" [uploadPath]="'system/logo'" [accept]="'image/*'"
                    [label]="'header.systemlogo' | translate" [description]="'Upload service logo' | translate"
                    (fileIdChanged)="logoFileIdChanged($event)" (delete)="deleteLogo()">
                  </file-handler>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'header.systemfavicon' | translate }}</label>
                  <file-handler [fileId]="faviconUrl" [uploadPath]="'system/favicon'" [accept]="'image/*'"
                    [label]="'header.systemfavicon' | translate" [description]="'Upload system favicon'"
                    (fileIdChanged)="faviconFileIdChanged($event)" (delete)="deleteFavicon()">
                  </file-handler>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'Footer' | translate }}</label>
                  <div class="table-items">
                    <div class="item">
                      <div class="row">
                        <div class="col-10 align-items-center justify-content-start">
                          <ckeditor [editor]="Editor" [config]="config" class="w-100" [(ngModel)]="footer_content">
                          </ckeditor>
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                          <button class="editBtn btn-dark mt-3" (click)="updateFooter()">{{ 'Update' | translate
                            }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'service.theme' | translate }}</label>
                  <div class="table-items">
                    <div class="item">
                      <div class="row">
                        <div class="col align-items-center justify-content-start">
                          <select label="" name="systemProperties.customTheme"
                            [(ngModel)]="systemProperties.customTheme" (change)="updateServiceProperties()"
                            class="form-control">
                            <!--                            <option value="default-theme">-->
                            <!-- TODO: Should we keep this? -->
                            <!--                              {{ 'service.defaultTheme' | translate }}-->
                            <!--                            </option>-->
                            <option value="modern-theme">
                              {{ 'service.modernTheme' | translate }}
                            </option>
                            <!--                            <option value="flat-theme">-->
                            <!-- TODO: Should we keep this? -->
                            <!--                              {{ 'service.flatTheme' | translate }}-->
                            <!--                            </option>-->
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'Categories' | translate }}</label>
                  <div class="table-items">
                    <div class="item"
                      *ngFor="let cat of allCategories; let first = first; let last = last; let i = index">
                      <div class="row">
                        <div class="col-10 align-items-center justify-content-start">
                          {{ cat.category | translate }}
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                          <i class="fas fa-times btn-xs btn-bordered btn-danger btn-icon item-remove"
                            (click)="removeCatecory(cat); $event.stopPropagation()"></i>
                        </div>
                      </div>
                    </div>
                    <div class="item">
                      <div class="row">
                        <div class="col-10 align-items-center justify-content-start">
                          <input class="form-control" type="text" [(ngModel)]="newCategory" #name="ngModel"
                            placeholder="{{ 'Add category' | translate }}">
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                          <button
                            class="editBtn  btn-dark {{ newCategory && (newCategory.length >= 2 && newCategory.length <= 256) ? '' : 'block' }}"
                            (click)="submitEditOnFocus();$event.stopPropagation()">{{ 'Add' | translate }}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <groups [systemProperties]="systemProperties"></groups>
            <div class="form-group">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'Homepage URL' | translate }}</label>
                  <div class="table-items">
                    <div class="item">
                      <div class="row">
                        <div class="col-10">
                          <input type="text" name="homepageUrl" [(ngModel)]="systemProperties.homepageUrl"
                            class="form-control">
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                          <button class="editBtn btn-dark" (click)="updateServiceProperties()">
                            {{ 'Update' | translate }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'AI model name' | translate }}</label>
                  <div class="table-items">
                    <div class="item">
                      <div class="row">
                        <div class="col-10">
                          <input type="text" name="aiModelName" [(ngModel)]="systemProperties.aiModelName"
                            title="Supported values: 'openai', 'mistral', 'gemini', 'gemma', 'exaone', 'qwen'"
                            class="form-control">
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                          <button class="editBtn btn-dark" (click)="updateServiceProperties()">
                            {{ 'Update' | translate }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'AI extraction endpoint' | translate }}</label>
                  <div class="table-items">
                    <div class="item">
                      <div class="row">
                        <div class="col-10">
                          <input type="text" name="aiExtractionEndpoint"
                            [(ngModel)]="systemProperties.aiExtractionEndpoint"
                            title="Supported values: 'Sparrow.POST/extract_data', 'Sparrow.POST/extract_data_sparrow'"
                            class="form-control">
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                          <button class="editBtn btn-dark" (click)="updateServiceProperties()">
                            {{ 'Update' | translate }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'Delimiter' | translate }}</label>
                  <div class="table-items">
                    <div class="item">
                      <div class="row">
                        <div class="col-10">
                          <input type="text" name="delimiter" [(ngModel)]="systemProperties.delimiter"
                            class="form-control">
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                          <button class="editBtn btn-dark" (click)="updateServiceProperties()">
                            {{ 'Update' | translate }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group mt-0">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'Decimal separator' | translate }}</label>
                  <div class="table-items">
                    <div class="item">
                      <div class="row">
                        <div class="col-10">
                          <input type="text" name="decimalSeparator" [(ngModel)]="systemProperties.decimalSeparator"
                            class="form-control">
                        </div>
                        <div class="col-2 align-items-center justify-content-end">
                          <button class="editBtn btn-dark" (click)="updateServiceProperties()">
                            {{ 'Update' | translate }}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedTab === 'locales'" class="p-4">
            <language></language>
            <currency></currency>
          </div>

          <div *ngIf="selectedTab === 'display'" class="p-4">
            <div class="form-group mt-0">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'display_system.properties' | translate }}</label>
                  <div class="table-items">
                    <ng-container *ngFor="let prop of systemProperties.displaySystemProperties; let last = last;">
                      <div class="item" *ngIf="prop.name !== 'request_release_notes_at_publishing'
                        && prop.name !== 'hide_applications_list'
                        && prop.name !== 'close_applications_list'">
                        <div class="row cursor-row" (click)="prop.enabled = !prop.enabled; updateServiceProperties()">
                          <div class="col-auto align-items-center justify-content-start">
                            <i
                              class="fas icon-large {{prop.enabled ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}}"></i>
                          </div>
                          <div class="col pl-0 align-items-center justify-content-start">
                            {{ prop.name | translate }}
                          </div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedTab === 'publishing'" class="p-4">
            <div class="form-group mt-0">
              <div class="row">
                <div class="col">
                  <div class="table-items">
                    <div class="item">
                      <div class="row cursor-row"
                        (click)="publishBPAOption.enabled = !publishBPAOption.enabled; updateServiceProperties()">
                        <div class="col-auto align-items-center justify-content-start">
                          <i
                            class="fas icon-large {{publishBPAOption.enabled ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}}"></i>
                        </div>
                        <div class="col pl-0 align-items-center justify-content-start">
                          {{ publishBPAOption.name | translate }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <instances></instances>
            <div class="form-group mb-0">
              <div class="row">
                <div class="col">
                  <label class="input-label">{{ 'deploy.properties' | translate }}</label>
                  <div class="table-items">
                    <div class="item" *ngFor="let prop of systemProperties.deployProperties; let last = last;">
                      <div class="row cursor-row"
                        (click)="prop.deployEnabled = !prop.deployEnabled; updateServiceProperties()">
                        <div class="col-auto">
                          <i
                            class="fas icon-large {{prop.deployEnabled ? 'fa-toggle-large-on toggle-primary' : 'fa-toggle-large-on fa-flip-horizontal toggle-disabled'}}"></i>
                        </div>
                        <div class="col pl-0">{{prop.systemId}}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedTab === 'datasources'" class="p-4">
            <swagger-url></swagger-url>
          </div>

          <div *ngIf="selectedTab === 'time'" class="p-4">
            <time-management></time-management>
          </div>

        </div>

      </div>
    </div>
  </div>

</app-wrapper>